"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ContentTabs_1 = __importDefault(require("../components/contentTabs/ContentTabs"));
var DropdownsContentTab_1 = __importDefault(require("../components/tabContent/DropdownsContentTab"));
var InputArticleIdContentTab_1 = __importDefault(require("../components/tabContent/InputArticleIdContentTab"));
var SparepartsTable_1 = __importDefault(require("../components/sparepartsTable/SparepartsTable"));
var GlobalStateContext_1 = require("../utils/GlobalStateContext");
var SparepartsView = function () {
    // global state context things
    var context = (0, react_1.useContext)(GlobalStateContext_1.GlobalStateContext);
    var state = context.state, setState = context.setState;
    // asure init
    if (state.pleaseSelectOption === undefined)
        return (react_1.default.createElement(react_1.default.Fragment, null));
    return (react_1.default.createElement("div", { className: "spr-spareparts-view" },
        react_1.default.createElement(ContentTabs_1.default, null),
        react_1.default.createElement("div", { className: "spr-spareparts-view__tab-content mb-4" },
            state.currentTabIndex === 0 && (react_1.default.createElement(DropdownsContentTab_1.default, null)),
            state.currentTabIndex === 1 && (react_1.default.createElement(InputArticleIdContentTab_1.default, null))),
        react_1.default.createElement(SparepartsTable_1.default, null)));
};
// set the display name for debugger
SparepartsView.displayName = "Spareparts View";
// export component
exports.default = SparepartsView;
